import store from "../../Debug/store";

/**
 * Generates dynamic padding for map flyTo or fitBounds.
 * Accesses values directly from the global Redux store.
 */
export const get_dynamic_map_padding = () => {
  // Get the latest state directly from the global Redux store
  const state = store.getState();
  const { layer, properties } = state;

  const { tableStatus } = layer || {};
  const { is_mobile, sidebar_left_status, sidebar_right_status, table_height } =
    properties || {};

  // Calculate and return the dynamic padding
  return {
    top: 70,
    bottom: tableStatus ? table_height || 0 : 50,
    left: !is_mobile && sidebar_left_status ? 325 : 50,
    right: !is_mobile && sidebar_right_status ? 365 : 50,
  };
};
